<template>
  <div class="page-register">
    <mod-web-header title="卖家注册" :status="1" />
    <div class="wrapper">
      <div class="mod-box">
        <form class="register-box" @submit.prevent="onRegister">
          <div class="title">请使用手机号注册账号</div>
          <z-input
            v-model.trim="mobile"
            class="item"
            :width="282"
            placeholder="请输入手机号"
            @input="onMobileInput"
            @focus="onFocus('mobile')"
          />
          <p :class="$addClass('error', [!errors.mobile, 'hide'])">* {{ errors.mobile }}</p>
          <div class="item">
            <z-input
              v-model.trim="pin"
              :width="162"
              placeholder="请输入6位验证码"
              @focus="onFocus('pin')"
            />
            <z-verification :mobile="mobile" @error="onError" @success="onSuccess" />
          </div>
          <p v-if="pinSuccess" class="success-text">* {{ pinSuccess }}</p>
          <p v-else :class="$addClass('error', [!errors.pin, 'hide'])">* {{ errors.pin }}</p>
          <z-input
            v-model.trim="password"
            class="item"
            type="password"
            :width="282"
            placeholder="请输入6-20位字母和数字组合密码"
            autocomplete="new-password"
            @focus="onFocus('password')"
          />
          <p :class="$addClass('error', [!errors.password, 'hide'])">* {{ errors.password }}</p>
          <z-input
            v-model.trim="confirmation"
            class="item"
            type="password"
            :width="282"
            placeholder="请再次输入密码确认"
            @focus="onFocus('confirmation')"
          />
          <p :class="$addClass('error', [!errors.confirmation, 'hide'])">
            * {{ errors.confirmation }}
          </p>
          <p class="options">
            <label
              ><z-checkbox
                v-model="checked"
                @change="onFocus('agree')"
              />我已阅读并接受&ensp;</label
            >
            <a href="javascript:void(0)" @click="onShowAgreement">《纵购商城用户服务协议》</a>
          </p>
          <p v-if="!errorText" :class="$addClass('error', [!errors.agree, 'hide'])">
            * {{ errors.agree }}
          </p>
          <p v-else class="error-text">* {{ errorText }}</p>
          <button class="submit-button" type="submit">同意并注册</button>
        </form>
      </div>
    </div>
    <mod-web-footer />
    <com-copyright />
    <agreement ref="agreement" @agree="onAgree" />
  </div>
</template>

<script>
import ModWebHeader from '@/components/mod-web-header'
import ModWebFooter from '@/components/mod-web-footer'
import ComCopyright from '@/components/com-copyright'
import ZVerification from '@/components/z-verification'
import Agreement from '@/views/agreement'
import { register } from '@/data'
import { regExp } from '@/utils'

export default {
  name: 'Register',
  components: {
    ComCopyright,
    ModWebHeader,
    ModWebFooter,
    ZVerification,
    Agreement
  },
  data() {
    return {
      mobile: '',
      pin: '',
      password: '',
      confirmation: '',
      checked: false,
      errorText: '',
      pinSuccess: '',
      errors: {}
    }
  },
  methods: {
    onAgree() {
      this.checked = true
    },
    onShowAgreement() {
      this.$refs.agreement.open()
    },
    onMobileInput() {
      this.mobile = this.mobile.substr(0, 11).replace(/[^0-9]/g, '')
    },
    onFocus(name) {
      const errors = { ...this.errors }
      errors[name] = ''
      this.errors = errors
      this.errorText = ''
      this.pinSuccess = ''
    },
    onError(error) {
      const errors = {}
      errors[error.field] = error.message
      this.errors = errors
      this.pinSuccess = ''
      this.errorText = ''
    },
    onSuccess(message) {
      this.errors = {}
      this.pinSuccess = message
      this.errorText = ''
    },
    async onRegister() {
      const { mobile, pin, password, confirmation, checked } = this
      let errors = {}

      if (!mobile) {
        errors.mobile = '请输入手机号'
      }

      if (!regExp.MOBILE.test(mobile)) {
        errors.mobile = '请输入正确的手机号'
      }

      if (!pin) {
        errors.pin = '请输入验证码'
      }

      if (!password) {
        errors.password = '请输入密码'
      }

      if (!regExp.PASSWORD.test(password)) {
        errors.password = '请输入6-20位字母和数字组合密码'
      }

      if (!confirmation) {
        errors.confirmation = '请再次输入密码'
      }

      if (password !== confirmation) {
        errors.confirmation = '两次输入的密码不一致，请重新输入'
      }

      if (!checked) {
        errors.agree = '请选择接受服务协议'
      }

      this.pinSuccess = ''

      if (Object.keys(errors).length > 0) {
        this.errors = errors
        return
      }

      const data = await register({ mobile, pin, password, confirmation })

      if (data.error_code === 0) {
        ;(this.mobile = ''),
          (this.pin = ''),
          (this.password = ''),
          (this.confirmation = ''),
          (this.checked = false),
          (this.errorText = ''),
          (this.pinSuccess = ''),
          (this.errors = {})

        this.$confirm({
          title: '注册成功',
          content: `恭喜您，【${mobile}】注册已成功！`,
          okText: '马上登录',
          cancelText: '返回首页',
          mask: () => true,
          ok: () => {
            this.$router.push('/login')
          },
          cancel: () => {
            this.$router.push('/')
          }
        })
      } else if (data.errors.length > 0) {
        data.errors.forEach((item) => {
          errors[item.field] = item.message
        })
      } else {
        this.errorText = data.message
      }

      this.errors = errors
    }
  }
}
</script>

<style lang="postcss">
.page-register {
  .wrapper {
    height: 520px;
    padding: 35px 0;
    background-color: #333;

    .mod-box {
      background: url(../assets/images/bg-register.png) no-repeat 90% center;
    }
  }

  .z-checkbox {
    margin-right: 5px;
    vertical-align: -3px;
  }

  .register-box {
    width: 332px;
    height: 450px;
    background-color: #fff;
    border-radius: 5px;
    margin-left: 45px;
    padding: 25px;

    .z-input {
      height: 38px;
      line-height: 28px;
    }

    .title {
      line-height: 36px;
      border-bottom: 1px solid #ccc;
      margin-bottom: 5px;
    }

    .item {
      margin-top: 5px;
      width: 100%;
    }

    .options {
      font-size: 12px;
      margin-top: 10px;

      a:hover {
        color: #f00;
      }
    }

    .error,
    .error-text,
    .success-text {
      font-size: 12px;
      padding: 0 5px;
      color: #c81613;
      height: 18px;

      &.space {
        margin-top: 63px;
      }

      &.hide {
        visibility: hidden;
      }
    }

    .success-text {
      color: #19be6b;
    }

    .submit-button {
      height: 44px;
      background-color: #fabe00;
      border: none;
      width: 100%;
      border-radius: 5px;
      font-size: 16px;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}
</style>
